// extracted by mini-css-extract-plugin
export default {"quickLinks":"quickLinks-121EW"};